import vuetify from "./vuetify";
import VuetifyUseDialog from "vuetify-use-dialog";
import { createPinia } from "pinia";

export function registerPlugins(app) {
  app.use(vuetify);
  app.use(VuetifyUseDialog, {
    snackbar: {
      snackbarProps: {
        location: "top",
      },
    },
  });
  app.use(createPinia());
}
